import { Container, Box, Typography, Divider, Link, Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { COMPANY, companyFullAddress } from "../config/companyInfo";

// Srpska verzija je pravno merodavna (usklađena sa ChipCard zahtevima);
// engleska je informativni prevod sa klauzulom o merodavnosti.
export default function PrivacyPage() {
    const { i18n } = useTranslation();
    const isEn = (i18n.resolvedLanguage || i18n.language || "sr").startsWith("en");
    return isEn ? <PrivacyEn /> : <PrivacySr />;
}

function PrivacySr() {
    const navigate = useNavigate();

    return (
        <Box sx={{ minHeight: "calc(100vh - 64px)", bgcolor: "grey.100", py: 4 }}>
            <Container maxWidth="md">
                <Box sx={{ bgcolor: "white", borderRadius: 3, p: { xs: 3, md: 5 } }}>
                    <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>
                        Politika privatnosti
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                        Zaštita podataka o ličnosti korisnika platforme {COMPANY.brandName}. Deo je i{" "}
                        <Link onClick={() => navigate("/uslovi-kupovine")} sx={{ cursor: "pointer", fontWeight: 700 }}>
                            Opštih uslova korišćenja
                        </Link>.
                    </Typography>
                    <Divider sx={{ mb: 3 }} />

                    <Section title="1. Rukovalac podacima">
                        Rukovalac podacima o ličnosti je {COMPANY.legalName}, sa sedištem na adresi {companyFullAddress}
                        (PIB: {COMPANY.taxId}, matični broj: {COMPANY.registrationNumber}). Za sva pitanja u vezi sa
                        zaštitom podataka možete nas kontaktirati na e-mail {COMPANY.email} ili telefon {COMPANY.phone}.
                    </Section>

                    <Section title="2. Zaštita privatnosti korisnika">
                        U ime platforme {COMPANY.brandName} obavezujemo se da ćemo čuvati privatnost svih naših kupaca.
                        Prikupljamo samo neophodne, osnovne podatke o kupcima/korisnicima i podatke neophodne za
                        poslovanje i informisanje korisnika u skladu sa dobrim poslovnim običajima i u cilju pružanja
                        kvalitetne usluge. Dajemo kupcima mogućnost izbora, uključujući mogućnost odluke da li žele ili
                        ne da se izbrišu sa mailing lista koje se koriste za marketinške kampanje. Svi podaci o
                        korisnicima/kupcima se strogo čuvaju i dostupni su samo zaposlenima kojima su ti podaci nužni za
                        obavljanje posla. Svi zaposleni odgovorni su za poštovanje načela zaštite privatnosti.
                    </Section>

                    <Section title="3. Koje podatke prikupljamo i u koju svrhu">
                        U procesu kupovine prikupljamo isključivo podatke neophodne za realizaciju usluge:
                        {"\n"}- e-mail adresu — radi dostave karte i fiskalnog računa i informisanja o narudžbini;
                        {"\n"}- broj telefona (opciono) — radi kontakta u slučaju kašnjenja ili promene reda vožnje;
                        {"\n"}- podatke o putovanju (relacija, datum, polazak, sedište, tip karte) — radi izvršenja
                        rezervacije i izdavanja karte.
                        {"\n\n"}
                        Obrada se vrši radi zaključenja i izvršenja ugovora o prevozu, izdavanja i dostave karte,
                        fiskalizacije u skladu sa zakonom, kao i radi rešavanja eventualnih reklamacija. Podatke čuvamo
                        u rokovima propisanim važećim propisima.
                    </Section>

                    <Section title="4. Zaštita poverljivih podataka o transakciji">
                        Prilikom unošenja podataka o platnoj kartici, poverljive informacije se prenose putem javne
                        mreže u zaštićenoj (kriptovanoj) formi upotrebom SSL protokola i PKI sistema, kao trenutno
                        najsavremenije kriptografske tehnologije. Sigurnost podataka prilikom kupovine garantuje procesor
                        platnih kartica Chip Card a.d. Beograd, pa se tako kompletan proces naplate obavlja na
                        stranicama Chip Card-a. Nijednog trenutka podaci o platnoj kartici nisu dostupni našem sistemu.
                    </Section>

                    <Section title="5. Poverljivost podataka i ustupanje trećim licima">
                        Lični i adresni podaci korisnika koji se predočavaju prilikom procesa kupovine smatraju se
                        poslovnom tajnom. Obavezujemo se da nećemo prodavati, ustupati niti razmenjivati podatke o
                        korisniku ili podatke o platnoj kartici u bilo kojoj formi trećim licima, osim kada je to
                        neophodno za izvršenje same transakcije (procesor Chip Card a.d. Beograd i prevoznik čiju kartu
                        kupujete) ili kada to zahteva nadležni državni organ.
                        {"\n\n"}
                        Od korisnika nikada ne zahtevamo niti u bilo kojoj formi arhiviramo podatke o platnoj kartici
                        (broj kartice, datum isteka, CVV/CVC broj).
                    </Section>

                    <Section title="6. Prava korisnika">
                        U skladu sa Zakonom o zaštiti podataka o ličnosti, korisnik ima pravo na pristup svojim
                        podacima, na ispravku netačnih podataka, na brisanje, na ograničenje obrade i na prigovor. Zahtev
                        za ostvarivanje ovih prava možete uputiti na e-mail {COMPANY.email}.
                    </Section>

                    <Section title="7. Marketinške poruke">
                        Ukoliko budemo slali promotivne poruke koristeći podatke dobijene kroz obradu transakcije, o tome
                        ćemo Vas prethodno obavestiti i omogućiti Vam da u svakom trenutku odbijete učešće u marketinškoj
                        kampanji, jednostavnom odjavom sa mailing liste.
                    </Section>

                    <Section title="8. Povraćaj sredstava">
                        U slučaju vraćanja sredstava kupcu koji je prethodno platio platnom karticom, delimično ili u
                        celosti, a bez obzira na razlog vraćanja, {COMPANY.legalName} je u obavezi da povraćaj vrši
                        isključivo preko VISA, EC/MC i Maestro metoda plaćanja, odnosno na račun platne kartice
                        korišćene za plaćanje. Uslovi otkaza i reklamacije detaljno su opisani u{" "}
                        <Link onClick={() => navigate("/uslovi-kupovine")} sx={{ cursor: "pointer", fontWeight: 700 }}>
                            Opštim uslovima korišćenja
                        </Link>.
                    </Section>

                    <Section title="9. Kolačići (cookies)">
                        Platforma koristi kolačiće neophodne za osnovno funkcionisanje sajta (npr. održavanje sesije i
                        procesa kupovine). Nastavkom korišćenja platforme saglasni ste sa upotrebom neophodnih kolačića.
                    </Section>

                    <Section title="10. Izmene politike">
                        {COMPANY.brandName} zadržava pravo izmene ove Politike privatnosti. Važeća verzija uvek je
                        objavljena na ovoj stranici.
                    </Section>
                </Box>
            </Container>
        </Box>
    );
}

function PrivacyEn() {
    const navigate = useNavigate();

    return (
        <Box sx={{ minHeight: "calc(100vh - 64px)", bgcolor: "grey.100", py: 4 }}>
            <Container maxWidth="md">
                <Box sx={{ bgcolor: "white", borderRadius: 3, p: { xs: 3, md: 5 } }}>
                    <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>
                        Privacy Policy
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        Protection of personal data of users of the {COMPANY.brandName} platform. It also forms part
                        of the{" "}
                        <Link onClick={() => navigate("/uslovi-kupovine")} sx={{ cursor: "pointer", fontWeight: 700 }}>
                            General Terms of Use
                        </Link>.
                    </Typography>
                    <Alert severity="info" sx={{ mb: 3 }}>
                        This English translation is provided for convenience only. In case of any
                        discrepancy, the Serbian version prevails.
                    </Alert>
                    <Divider sx={{ mb: 3 }} />

                    <Section title="1. Data controller">
                        The controller of personal data is {COMPANY.legalName}, with its registered office at{" "}
                        {companyFullAddress} (PIB: {COMPANY.taxId}, registration number: {COMPANY.registrationNumber}).
                        For any questions regarding data protection, you can contact us by e-mail at {COMPANY.email} or
                        by phone at {COMPANY.phone}.
                    </Section>

                    <Section title="2. Protection of user privacy">
                        On behalf of the {COMPANY.brandName} platform, we undertake to protect the privacy of all our
                        customers. We collect only the necessary, basic data about customers/users and data necessary
                        for business operations and informing users, in line with good business practices and with the
                        aim of providing a quality service. We give customers a choice, including the option to decide
                        whether they wish to be removed from mailing lists used for marketing campaigns. All
                        customer/user data is strictly protected and accessible only to employees who need it to
                        perform their work. All employees are responsible for respecting the principles of privacy
                        protection.
                    </Section>

                    <Section title="3. What data we collect and for what purpose">
                        During the purchase process, we collect only the data necessary to provide the service:
                        {"\n"}- e-mail address — for delivering the ticket and fiscal receipt and informing you about
                        your order;
                        {"\n"}- phone number (optional) — for contact in case of delays or timetable changes;
                        {"\n"}- travel data (route, date, departure, seat, ticket type) — for making the reservation
                        and issuing the ticket.
                        {"\n\n"}
                        Processing is carried out for the purpose of concluding and performing the contract of
                        carriage, issuing and delivering the ticket, fiscalisation in accordance with the law, and
                        resolving any complaints. We retain data within the periods prescribed by applicable
                        regulations.
                    </Section>

                    <Section title="4. Protection of confidential transaction data">
                        When entering payment card details, confidential information is transmitted over the public
                        network in protected (encrypted) form using the SSL protocol and PKI systems, as the currently
                        most advanced cryptographic technology. Data security during purchase is guaranteed by the
                        payment card processor Chip Card a.d. Belgrade, so the complete payment process takes place on
                        Chip Card's pages. At no point are payment card details accessible to our system.
                    </Section>

                    <Section title="5. Confidentiality and disclosure to third parties">
                        Personal and address data provided by users during the purchase process are considered a
                        business secret. We undertake not to sell, assign or exchange user data or payment card data in
                        any form to third parties, except where necessary for the execution of the transaction itself
                        (the processor Chip Card a.d. Belgrade and the carrier whose ticket you are purchasing) or
                        where required by a competent state authority.
                        {"\n\n"}
                        We never request from users, nor archive in any form, payment card data (card number, expiry
                        date, CVV/CVC code).
                    </Section>

                    <Section title="6. User rights">
                        In accordance with the Serbian Personal Data Protection Act, the user has the right to access
                        their data, to rectification of inaccurate data, to erasure, to restriction of processing and
                        to object. A request to exercise these rights can be sent to {COMPANY.email}.
                    </Section>

                    <Section title="7. Marketing messages">
                        If we send promotional messages using data obtained through transaction processing, we will
                        inform you in advance and enable you to opt out of the marketing campaign at any time by simply
                        unsubscribing from the mailing list.
                    </Section>

                    <Section title="8. Refunds">
                        In the event of a refund to a buyer who previously paid with a payment card, partially or in
                        full, and regardless of the reason for the refund, {COMPANY.legalName} is obliged to make the
                        refund exclusively via VISA, EC/MC and Maestro payment methods, i.e. to the account of the
                        payment card used for the payment. Cancellation and complaint conditions are described in
                        detail in the{" "}
                        <Link onClick={() => navigate("/uslovi-kupovine")} sx={{ cursor: "pointer", fontWeight: 700 }}>
                            General Terms of Use
                        </Link>.
                    </Section>

                    <Section title="9. Cookies">
                        The platform uses cookies necessary for the basic functioning of the website (e.g. maintaining
                        the session and the purchase process). By continuing to use the platform, you consent to the
                        use of necessary cookies.
                    </Section>

                    <Section title="10. Changes to this Policy">
                        {COMPANY.brandName} reserves the right to amend this Privacy Policy. The applicable version is
                        always published on this page.
                    </Section>
                </Box>
            </Container>
        </Box>
    );
}

function Section({ title, children }) {
    return (
        <Box sx={{ mb: 3 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1, color: "primary.main" }}>
                {title}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.8, whiteSpace: "pre-line" }}>
                {children}
            </Typography>
        </Box>
    );
}
